import axios from 'axios';
import { AppStorage } from '../interfaces/host';

const axiosApiInstance = axios.create();

export default function createApiInstance(infoData: AppStorage) {
  axiosApiInstance.interceptors.request.use(
    async (config) => {
      config.headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${infoData.tokenClaims}`
      };

      config.baseURL = `${infoData.baseUrl}/cauth/api/turbo`;
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
}

export async function apiGet<T, U>(url: string, options?: T): Promise<U> {
  const { data } = await axiosApiInstance.get<U>(url, options);
  return data;
}

export async function apiPut<T, U = any, V = any>(url: string, body?: U, options?: T): Promise<V> {
  const { data } = await axiosApiInstance.put(url, body, options);
  return data;
}

export async function apiDelete<V = any>(url: string): Promise<V> {
  const { data } = await axiosApiInstance.delete(url);
  return data;
}

export async function apiPatch<T, U = any, V = any>(url: string, body?: U, options?: T): Promise<V> {
  const { data } = await axiosApiInstance.patch(url, body, options);
  return data;
}

export async function apiPost<T, U = any, V = any>(url: string, body?: U, options?: T): Promise<V> {
  const { data } = await axiosApiInstance.post(url, body, options);
  return data;
}
